module.exports = __webpack_public_path__ + "img/movil.c45b77d6.webp";